import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { action, computed, observable, reaction } from 'mobx';
import MobxState from '../abstract/MobxState';
import { createObservableInstance } from '../helpers';
import LandlordState from './LandlordState';
import NoticesState from './NoticesState';
import PaymentsState from './PaymentsState';
import PublicAccountState from './PublicAccountState';
import ProfileState from './ProfileState';
import RecentPropertiesState from './RecentPropertiesState';
import SavedPropertiesState from './SavedPropertiesState';
import TenantState from './TenantState';

class UserDataState extends MobxState {
  init() {
    super.init();

    this.root = this;

    onAuthStateChanged(getAuth(), (u) => this.setUserImpl(u));

    this.publicAccount = createObservableInstance(
      PublicAccountState,
      this.root
    );
    this.profile = createObservableInstance(ProfileState, this.root);
    this.payments = createObservableInstance(PaymentsState, this.root);
    this.notices = createObservableInstance(NoticesState, this.root);
    this.savedProperties = createObservableInstance(
      SavedPropertiesState,
      this.root
    );
    this.recentProperties = createObservableInstance(
      RecentPropertiesState,
      this.root
    );

    this.reactions_.push(
      reaction(
        () => this.publicAccount.data?.profileType,
        () => {
          this.state?.destroy();

          if (this.publicAccount.isLandlordType)
            this.state = createObservableInstance(LandlordState, this.root);
          else if (this.publicAccount.isTenantType)
            this.state = createObservableInstance(TenantState, this.root);
          else this.state = null;
        }
      )
    );
  }

  isReady = false;

  userImpl = null;

  state = null;

  get isInitialized() {
    return this.isReady && (this.userImpl ? this.error || !!this.state : true);
  }

  get error() {
    return this.profile.error || this.publicAccount.error;
  }

  setUserImpl(userImpl) {
    console.log('[UserDataState][setUserImpl]', userImpl);
    this.userImpl = userImpl;
    this.isReady = true;
  }

  destroy() {
    super.destroy();

    this.state?.destroy();
    this.publicAccount.destroy();
    this.profile.destroy();
  }
}

UserDataState.annotations = {
  ...MobxState.annotations,
  state: observable.ref,
  userImpl: observable.ref,
  setUserImpl: action,
  isInitialized: computed,
  error: computed,
  isReady: observable,
};

export default UserDataState;
